<template>
  <div class="project-overview_container">
    <div id="project-photos" class="carousel slide">
      <div class="carousel-inner">
        <div v-for="(photoUrl, index) in photosToShow"
             :key="index"
             class="carousel-item"
             :class="{ active: index === 0 }"
             :style="`background-image: url('${photoUrl}');`">
        </div>
      </div>

      <a v-if="hasPhotos && (project.general?.photoUrls?.length ?? 0) > 1"
         class="carousel-control-prev"
         href="#project-photos"
         role="button"
         data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a v-if="hasPhotos && (project.general?.photoUrls?.length ?? 0) > 1"
         class="carousel-control-next"
         href="#project-photos"
         role="button"
         data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>

    <div class="project-overview_left">
      <div class="clearfix">
        <div class="float-left">
          <span class="text-muted money-caption">Набрано</span>
          <money :money="investedSumSafe"/>
        </div>
        <div class="float-right text-right">
          <span class="text-muted money-caption">Цель</span>
          <money :money="loanSumSafe"/>
        </div>
      </div>
      <invest-progress-bar
          :loan-sum="loanSumSafe"
          :invested-sum="investedSumSafe"
          :reservation-sum="totalReservedSumSafe"
          :progress-bar-height="20"/>
      <div class="mb-2">
        <div class="clearfix">
          <div class="float-left">
            <span class="text-muted money-caption">Сумма в обработке</span>
            <money :money="totalReservedSumSafe"/>
          </div>
          <div class="float-right text-right">
            <span class="text-muted money-caption">Свободный остаток</span>
            <money :money="freeSum"/>
          </div>
        </div>
      </div>
      <div class="float-left">
        <span class="text-muted money-caption">Инвесторов</span>
        {{ countInvestorsSafe }}
      </div>
    </div>
  </div>
</template>

<script>
import Money from "@/components/common/components/Money.vue";
import InvestProgressBar from "@/components/common/components/InvestProgressBar.vue";
import WithoutPhoto from '@/assets/img/without-photo.png';
import {Money as ApiMoney} from "@/utils/api-client";

export default {
  name: "DetailedProjectOverview",
  components: {InvestProgressBar, Money},
  props: {
    project: {
      type: Object,
      required: true
    },
    projectStatus: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      withoutPhoto: WithoutPhoto
    }
  },
  computed: {
    // reservationSum() {
    //   if (!this.project || !this.project.loan) return new ApiMoney(0, "RUB");
    //
    //   const collateralRegistrationSum = this.project.loan.collateralRegistrationSum
    //       ? this.project.loan.collateralRegistrationSum.amount
    //       : 0;
    //
    //   const reservationAmount = this.project.reservations.reduce((total, el) => {
    //     return total + el.reservationRemain.amount;
    //   }, 0);
    //
    //   return new ApiMoney(reservationAmount + collateralRegistrationSum, this.project.loan.loanSum.currencyCode);
    // },
    zeroRub() {
      return new ApiMoney(0, "RUB");
    },
    investedSumSafe() {
      return this.project?.loan?.investedSum ?? this.zeroRub;
    },
    loanSumSafe() {
      return this.project?.loan?.loanSum ?? this.zeroRub;
    },
    totalReservedSumSafe() {
      return this.project?.loan?.totalReservedSum ?? this.zeroRub;
    },
    countInvestorsSafe() {
      return this.project?.loan?.countInvestors ?? 0;
    },
    freeSum() {
      const loan = this.project?.loan;
      if (!loan?.loanSum || loan.totalReservedSum == null || loan.investedSum == null) {
        return this.zeroRub;
      }
      const remainingAmount =
          loan.loanSum.amount - loan.totalReservedSum.amount - loan.investedSum.amount;
      return new ApiMoney(Math.max(remainingAmount, 0), loan.loanSum.currencyCode);
    },
    hasPhotos() {
      return Array.isArray(this.project?.general?.photoUrls) && this.project.general.photoUrls.length > 0;
    },
    photosToShow() {
      return this.hasPhotos ? this.project.general.photoUrls : [this.withoutPhoto];
    }
  }
};
</script>

<style lang="scss" scoped>
.project-overview {
  &_container {
    display: flex;
    flex-direction: column;
    width: 59%;
    gap: 0.5rem;
    @media (max-width: 768px) {
      width: 100%;
    }
  }

  &_left {
    display: flex;
    flex-direction: column;
    border-radius: 0.8rem;
    padding: 2rem;
    background: var(--white);
    height: 100%;
  }
}

#project-photos {
  position: relative;

  .carousel-caption {
    position: absolute;

    .badge-secondary {
      background: #252c54;
      font-size: 1rem;
      font-weight: 500;
    }
  }

  .carousel-inner {
    .carousel-item {
      height: 32.75rem;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      border-radius: 0.8rem;

    }
  }

  .carousel-control-prev,
  .carousel-control-next {
    color: #05B768;
  }
}

.text-muted {
  font-size: 0.9rem;
}

.money-caption {
  margin-right: 0.5rem;
}
</style>
